export function setChatTheme(theme) {
    const html = document.documentElement;
    if (theme === 'dark') {
        html.setAttribute('data-theme', 'dark');
    } else if (theme === 'darkBlue') {
        html.setAttribute('data-theme', 'darkBlue');
    }
    else {
        html.removeAttribute('data-theme');
    }
}
